import { useEndorsementSummaryMutations } from '@ContractBuilder/hooks/useEndorsementSummaryMutations';
import { useEntityStore } from '@ContractBuilder/store';

export const useBlockActions = () => {
  const {
    addBlockFromLibraryToSubmission,
    addBlockFromLibraryToTemplate,
    createBlock,
    createBlockInLibrary,
    deactivateBlockInLibrary,
    deleteBlock,
    reactivateBlockInLibrary,
    replaceBlockForBlockInLibrary,
    restoreBlockInLibrary,
    updateBlock,
    updateBlockInLibrary,
  } = useEntityStore(
    ({
      addBlockFromLibraryToSubmission,
      addBlockFromLibraryToTemplate,
      createBlock,
      createBlockInLibrary,
      deactivateBlockInLibrary,
      deleteBlock,
      reactivateBlockInLibrary,
      replaceBlockForBlockInLibrary,
      restoreBlockInLibrary,
      updateBlock,
      updateBlockInLibrary,
    }) => ({
      addBlockFromLibraryToSubmission,
      addBlockFromLibraryToTemplate,
      createBlock,
      createBlockInLibrary,
      deactivateBlockInLibrary,
      deleteBlock,
      reactivateBlockInLibrary,
      replaceBlockForBlockInLibrary,
      restoreBlockInLibrary,
      updateBlock,
      updateBlockInLibrary,
    }),
  );

  const {
    createSummaryBlock,
    deleteSummaryBlock,
    hideBlockFromPreview,
    showBlockInPreview,
    restoreAllBlocksHiddenFromPreview,
    updateSummaryBlock,
  } = useEndorsementSummaryMutations();

  return {
    addBlockFromLibraryToSubmission,
    addBlockFromLibraryToTemplate,
    createBlock,
    createBlockInLibrary,
    createSummaryBlock: createSummaryBlock.mutateAsync,
    deactivateBlockInLibrary,
    deleteBlock,
    deleteSummaryBlock: deleteSummaryBlock.mutateAsync,
    hideBlockFromPreview: hideBlockFromPreview.mutateAsync,
    showBlockInPreview: showBlockInPreview.mutateAsync,
    reactivateBlockInLibrary,
    replaceBlockForBlockInLibrary,
    restoreAllBlocksHiddenFromPreview: restoreAllBlocksHiddenFromPreview.mutateAsync,
    restoreBlockInLibrary,
    updateBlock,
    updateBlockInLibrary,
    updateSummaryBlock: updateSummaryBlock.mutateAsync,
  };
};
